module.exports = __webpack_public_path__ + "static/media/news_1.76bea7cd.jpg";